import React from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Hidden,
  Typography,
} from '@material-ui/core';

import AppStore from '../../../../../../assets/img/prelogin/AppStore.png';
import HandWithCell from '../../../../../../assets/img/prelogin/HandWithCell.png';
import PlayStore from '../../../../../../assets/img/prelogin/PlayStore.png';
import { appConfig } from '../../../../../../config/app';
import { CustomEvents } from '../../../../../../constants/analytics.constant';
import useLogEventInAnalytics from '../../../../../../hooks/useLogAnalyticsEvent';
import { useStyles } from './styles';

const StoresCard = () => {
  const classes = useStyles();
  const { logEvent } = useLogEventInAnalytics();

  return (
    <Card className={classes.cardContainer}>
      <CardContent>
        <Grid container direction="row">
          <Hidden smUp>
            <Grid item xs={2}>
              <CardMedia
                className={classes.img}
                component="img"
                image={HandWithCell}
              />
            </Grid>
          </Hidden>
          <Grid item xs={10} sm={12}>
            <Typography className={classes.storeBoxSubtitle}>
              ¡NO TE PIERDAS NADA!
            </Typography>
            <Typography className={classes.storeBoxTitle}>
              Descargá gratis nuestra app
            </Typography>
            <Hidden xsDown>
              <CardMedia
                className={classes.img}
                component="img"
                image={HandWithCell}
              />
            </Hidden>
            <Grid container direction="row" justify="center" spacing={4}>
              <Box className={classes.storesButtonBox}>
                <Button
                  onClick={async () =>
                    await logEvent(CustomEvents.DOWNLOAD_APP_ANDROID)
                  }
                  disableRipple
                  href={`${appConfig.APIS.BASE_NEW}/apps/answer_play_store`}
                >
                  <CardMedia
                    className={classes.storesImg}
                    component="img"
                    image={PlayStore}
                  />
                </Button>
                <Button
                  onClick={async () =>
                    await logEvent(CustomEvents.DOWNLOAD_APP_IOS)
                  }
                  disableRipple
                  href={`${appConfig.APIS.BASE_NEW}/apps/answer_app_store`}
                >
                  <CardMedia
                    className={classes.storesImg}
                    component="img"
                    image={AppStore}
                  />
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

StoresCard.displayName = 'StoresCard';

export default StoresCard;
